export default [
  {
    path: '/reporting',
    redirect: '/reporting/usage'
  },
  {
    path: '/reporting/usage',
    name: 'Usage Reporting',
    component: () => import(/* webpackChunkName: "reporting" */ '@/views/reporting/UsageReportingView.vue')
  }
]
